import { createSelector } from '@reduxjs/toolkit';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { getWidgetDataAsyncData } from './getWidgetDataAsyncData';
export const getLatestWidgetData = createSelector(getWidgetDataAsyncData, widgetDataAsyncData => getData(widgetDataAsyncData));